import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { IoTBrand } from '@frontend/iot/types';
import React from 'react';

import { useIoTBrandSelect } from './iot-brand-select.controller';

const ID = 'iot-brand-select';
export const IoTBrandSelect = (props: Omit<SelectInputV2Props<IoTBrand>, 'options'>) => {
    const { options, isLoading } = useIoTBrandSelect();

    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            className={props.className}
            options={options}
            value={props.value}
            label={props.label || 'IoT brand'}
            required={props.required}
            onSelect={(value) => props.onSelect && props.onSelect(value as { label: string; value: string })}
            isLoading={isLoading}
        />
    );
};
